import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import SFAvatar from "../avatar";
import getStyled from "../../hooks/getStyled";
import { useNavigate } from "react-router-dom";
import { shortenName } from "../../helpers";
import { userService } from "../../index";
import SFThumbnailCard from "../thumbnailCard";

const { styled } = getStyled();

const StyledAvatar = styled(SFAvatar)(({ theme }) => ({
  height: 31,
  width: 31,
  fontSize: 14,
}));

const SFLaunchCard = ({
  title,
  subtitle,
  headerIcon,
  url,
  btnLabel,
  statistics,
  modifiedOn,
  modifiedBy,
  dataCallback,
  renderCallback,
  btnIcon,
  disabled,
  description = null,
  padding = false,
  paddingLogo = false,
  onClick = () => {},
}) => {
  const navigate = useNavigate();

  const [userDetails, setUserDetailsState] = useState(null);

  const [state, setState] = useState({
    item: {},
    loading: true,
  });

  useEffect(() => {
    if (!modifiedBy) return;

    const saveUser = async () => {
      let user;
      if (modifiedBy !== userService.SYSTEM_MODIFIED_NAME) {
        user = await userService.getUserDetails(modifiedBy);
      } else {
        user = { name: userService.SYSTEM_MODIFIED_NAME };
      }
      if (!user.name) {
        user = {
          ...user,
          name: modifiedBy
            .replaceAll(".", " ")
            .substr(0, modifiedBy.indexOf("@")),
        };
      }
      setUserDetailsState(user);
    };
    saveUser();
    if (dataCallback) {
      dataCallback().then((response) => {
        let item = {
          ...state.item,
          ...response.data,
        };
        setState({
          loading: false,
          item,
        });
      });
    }
  }, []);
  return (
    <SFThumbnailCard
      chips={
        dataCallback && <div className="progress">{renderCallback(state)}</div>
      }
      title={title}
      subtitle={subtitle}
      body={description}
      buttonLabel={btnLabel}
      buttonIcon={btnIcon}
      disabled={disabled}
      onClick={() => (url ? navigate(url) : onClick())}
      logo={headerIcon}
      padding={padding}
      paddingLogo={paddingLogo}
      numbers={
        statistics &&
        statistics.map((item) => ({
          label: item.description,
          count: item.value,
        }))
      }
      footer={
        modifiedBy &&
        modifiedOn && {
          owner: {
            avatar: <StyledAvatar name={userDetails?.name} />,
            name: shortenName(userDetails?.name),
          },
          date: modifiedOn,
        }
      }
    />
  );
};

SFLaunchCard.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.node,
  headerIcon: PropTypes.node,
  url: PropTypes.string,
  btnLabel: PropTypes.string,
  statistics: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      description: PropTypes.string.isRequired,
    })
  ),
  modifiedOn: PropTypes.string.isRequired,
  modifiedBy: PropTypes.string.isRequired,
  dataCallback: PropTypes.func,
  renderCallback: PropTypes.func,
  btnIcon: PropTypes.node,
  disabled: PropTypes.bool,
  description: PropTypes.string,
  padding: PropTypes.bool,
  paddingLogo: PropTypes.bool,
  onClick: PropTypes.func,
};

export default SFLaunchCard;
